import {
  NavbarFloatingAuthButton,
  NavbarFloatingBagButton,
  NavbarFloatingContainer,
  NavbarFloatingCurrentOrder,
  NavbarFloatingDrawer,
  NavbarFloatingGroupOrderHostIndicator,
  NavbarFloatingGroupOrderInviteeButton,
  NavbarFloatingLink,
  NavbarFloatingLocationButton,
  NavbarFloatingLogo,
  NavbarFloatingLogoPressable,
  NavbarFloatingMenuButton,
  NavbarFloatingNavLinksList,
  NavbarFloatingPageLink,
  NavbarFloatingPopup,
  NavbarFloatingPopupFooter,
  NavbarFloatingPrimaryNav,
  NavbarFloatingSecondaryNav,
  NavbarFloatingTextLink,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloating = {
  Container: NavbarFloatingContainer,
  Drawer: NavbarFloatingDrawer,
  PrimaryNav: NavbarFloatingPrimaryNav,
  Logo: NavbarFloatingLogo,
  LogoPressable: NavbarFloatingLogoPressable,
  Link: NavbarFloatingLink,
  NavLinksList: NavbarFloatingNavLinksList,
  MenuButton: NavbarFloatingMenuButton,
  SecondaryNav: NavbarFloatingSecondaryNav,
  AuthButton: NavbarFloatingAuthButton,
  GroupOrderHostIndicator: NavbarFloatingGroupOrderHostIndicator,
  GroupOrderInviteeButton: NavbarFloatingGroupOrderInviteeButton,
  LocationButton: NavbarFloatingLocationButton,
  BagButton: NavbarFloatingBagButton,
  PageLink: NavbarFloatingPageLink,
  Popup: NavbarFloatingPopup,
  PopupFooter: NavbarFloatingPopupFooter,
  CurrentOrder: NavbarFloatingCurrentOrder,
  TextLink: NavbarFloatingTextLink,
};
